import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import logoOrange from '../../../assets/images/logo_orange.png';
import { ContentWrapper } from '../../utils/components';
import '../../styles/Header.css';
import { useNavigate } from 'react-router-dom';

// NavItem component
const NavItem = ({ children, url, onClick, isActive }) => (
  <li>
    <Link
      to={url}
      onClick={onClick}
      className={`nav-link ${isActive ? 'active' : ''}`}
    >
      {children}
    </Link>
  </li>
);

NavItem.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};

// Menu items
const navItems = [
  { label: 'Home', path: '/' },
  { label: 'Over ons', path: '/over-ons' },
  { label: 'Diensten', path: '/onze-diensten' },
  { label: 'Wagens', path: '/tweedehands' },
  { label: 'Contact', path: '/contact' },
];

const Header = () => {

  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const handleMenuToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleNavItemClick = () => {
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onClickLogo = () => {
    navigate('/'); // ✅ navigeer naar homepagina
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  return (
    <div className="sticky">
      <div className="header-info-wrapper">
        <div className="content-wrapper">
          <div className="header-info-icon" id="home">
            <FaMapMarkerAlt />
            <p>Gentweg 26, 9940 Evergem</p>
          </div>
          <div className="header-info-icon">
            <FaPhone />
            <p>0479 71 04 37</p>
          </div>
        </div>
      </div>
      <header className="header-wrapper" id="scrollHeader">
        <ContentWrapper>
          <img
            src={logoOrange}
            alt="Logo auto-service thomas"
            className="logo-image"
            onClick={onClickLogo}
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onClickLogo()}
          />

          {/* Hamburger menu */}
          <div
            className="hamburger-wrapper"
            onClick={handleMenuToggle}
            role="button"
            tabIndex={0}
            aria-label="Toggle menu"
            onKeyDown={(e) => e.key === 'Enter' && handleMenuToggle()}
          >
            <div className={`hamburger ${isMenuOpen ? 'open' : ''}`}>
              <div />
              <div />
              <div />
            </div>
          </div>

          {isMenuOpen && (
            <div
              className="menu-overlay"
              onClick={handleMenuToggle}
              role="presentation"
            />
          )}

          {/* Mobile menu */}
          <nav
            className={`menu-wrapper ${isMenuOpen ? 'open' : ''}`}
            aria-label="Mobile navigation"
          >
            <ul className="nav">
              {navItems.map(({ label, path }) => (
                <NavItem
                  key={path}
                  url={path}
                  onClick={handleNavItemClick}
                  isActive={path === '/' ? location.pathname === '/' : location.pathname.startsWith(path)}
                >
                  {label}
                </NavItem>
              ))}
            </ul>
          </nav>

          {/* Desktop menu */}
          <nav className="desktop-menu" aria-label="Main navigation">
            <ul>
              {navItems.map(({ label, path }) => (
                <NavItem
                  key={path}
                  url={path}
                  onClick={handleNavItemClick}
                  isActive={path === '/' ? location.pathname === '/' : location.pathname.startsWith(path)}
                >
                  {label}
                </NavItem>
              ))}
            </ul>
          </nav>
        </ContentWrapper>
      </header>
    </div>
  );
};

export default Header;
